// src/components/retargeting/FacebookPixelProvider.tsx

import { useEffect } from 'react';
import { fbPixelService } from '@/services/retargeting/fb.pixel.service';

/**
 * FacebookPixelProvider Component
 * Initializes Facebook Pixel on app mount
 * Should be placed near the root of your app
 */
export const FacebookPixelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    useEffect(() => {
        // Initialize Facebook Pixel when component mounts
        fbPixelService.initialize();
    }, []);

    return <>{children}</>;
};